let env = process.env.REACT_APP_ENV
	? process.env.REACT_APP_ENV
	: process.env.NODE_ENV;

if (!env) {
	console.error('ENV: ', env);
	env = 'development';
}

let gameUrl = 'http://localhost:3000';
let apiURL = 'http://localhost:8080/api/';
let ticketsDbName = 'tickets';
let minSurveyParticipants = 1;
if (env === 'test' || env === 'demo') {
	gameUrl = 'cgl-grill-test.web.app';
	apiURL = 'https://cgl-grill-test.web.app/api/';
	if (env === 'demo') {
		gameUrl = 'cgl-grill-demo.web.app';
		apiURL = 'https://cgl-grill-demo.web.app/api/';
		ticketsDbName = 'tickets-demo';
		minSurveyParticipants = 5;
	}
}
if (env === 'production') {
	gameUrl = 'grilltraining.dk';
	apiURL = 'https://cgl-grill-production.web.app/api/';
	minSurveyParticipants = 5;
}



const appConfig = {
	env,
	ticketsDbName,
	gameUrl,
	apiURL,	
	name: 'Grill',
	cookiesAcceptedCookieName: 'grill_cookies_accepted',
	gameDataCookieName: 'grill_game_data',
	raffleEmail: 'mads@cphgamelab.dk',
	screenBaseWidth: 1920,
	defaultLanguage: 'da',
	minEmployeeIdLength: 4,
	maxEmployeeIdLength: 7,
	maxStarsPerModule: 3,
	inactivityLimitSeconds: 30,
	moduleDisabledDays: 7,
	minSurveyParticipants
};

export default appConfig;